import { dataFetched } from 'data/graphql'
import { apiCapableActionCreator } from '../apiActionHelpers'
import { getOrganizationId } from 'data/organizations/selectors'
import InvitesAPI from 'remote/invites'
import { actions as UIActions } from 'data/ui'

import {
  CREATE_INVITES,
  RESEND_INVITE,
  FETCH_INVITES,
  DELETE_INVITE,
} from './actionTypes'

export const createInvites = ({ invites }) => ({
  apiConfig,
  dispatch,
  graphQLClient,
}) => {
  return {
    type: CREATE_INVITES,
    payload: graphQLClient
      .mutate({
        query: InvitesAPI.createInvites,
        variables: {
          invites,
        },
      })
      .then(
        function onSuccess({ data, errors }) {
          if (errors) {
            return
          }
          const payload = data.createInvites
          dispatch(
            UIActions.createSuccessToasterMessage({
              title: 'Invitations successfully sent',
            })
          )
          dispatch(dataFetched(payload))
          return payload
        },
        function onError({ errors }) {
          dispatch(
            UIActions.createErrorToasterMessage({
              title: 'Error while sending invites',
              detail: errors[0].message,
            })
          )
          throw new Error(errors[0].message)
        }
      ),
  }
}

export const deleteInvite = apiCapableActionCreator(
  invite => ({ apiConfig }) => {
    return {
      type: DELETE_INVITE,
      payload: InvitesAPI.deleteInvite(apiConfig, { invite }),
      meta: {
        invite,
      },
    }
  }
)

export const resendInvite = apiCapableActionCreator(
  invite => ({ apiConfig }) => {
    return {
      type: RESEND_INVITE,
      payload: InvitesAPI.resendInvite(apiConfig, { invite }),
      meta: {
        invite,
      },
    }
  }
)

export const fetchInvites = apiCapableActionCreator(
  () => ({ apiConfig, getState }) => {
    const organizationId = getOrganizationId(getState())
    return {
      type: FETCH_INVITES,
      payload: InvitesAPI.listInvites(apiConfig, { organizationId }),
    }
  }
)
